import { ChangeDetectorRef, Directive } from '@angular/core';

import { combineLatest, map, Observable } from 'rxjs';

import { ApiFragment } from '../../../record/entities/api-fragment.entity';
import { CellOptions } from '../../../record/entities/cell-options/cell-options.entity';
import { BaseColumnComponent } from '../../../record/services/base-column-component';
import { Task } from '../../entities/task.entity';

/**
 * A cell whose value identifies the row's own taak.
 *
 * `Workflow.Tasks.Task` is an array on the subject's metadata, so a dossier carrying two open taken prints
 * both values in every one of its rows. These cells read the task DTO instead. A row that is not a taak has
 * no taak to read, and renders the default value.
 */
@Directive()
export abstract class TaskDtoCellComponent<O extends CellOptions = CellOptions> extends BaseColumnComponent<
    ApiFragment,
    O
> {
    readonly value$: Observable<string>;

    constructor(cd: ChangeDetectorRef) {
        super(cd);

        this.value$ = combineLatest([this.data$, this.defaultValue$]).pipe(
            map(([fragment, defaultValue]) =>
                fragment instanceof Task ? this.readFromTask(fragment) || defaultValue : defaultValue
            )
        );
    }

    protected abstract readFromTask(task: Task): string | undefined;
}
